export default __webpack_public_path__ + "static/media/V470_G_BD.9afe7699.pdf";